/**
 * Public Routes Plugin
 * 
 * This plugin explicitly defines routes that should be accessible without authentication.
 * It prevents any authentication redirects for these routes by intercepting and bypassing
 * the session manager's redirect logic for specified public paths.
 */
import { defineNuxtPlugin } from '#app'
import { onBeforeUnmount } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  // List of routes that should always be public
  const publicRoutes = [
    '/extra-packs',
    '/extra-packs/'
  ]

  // Function to check if a route is public
  const isPublicRoute = (path: string) => {
    return publicRoutes.some(route => 
      path === route || path.startsWith(`${route}/`)
    )
  }

  // Override any authentication middleware for these routes
  if (typeof window !== 'undefined') {
    // Create a special flag in sessionStorage that other auth code can check
    const updatePublicRouteFlag = () => {
      const currentPath = window.location.pathname
      
      if (isPublicRoute(currentPath)) {
        console.log('Public route detected, setting bypass flag:', currentPath)
        sessionStorage.setItem('public_route_bypass', 'true')
        
        // Also monitor for any redirect attempts and prevent them
        const originalPushState = window.history.pushState
        const originalReplaceState = window.history.replaceState
        
        // Intercept any attempts to redirect to /account or /login
        window.history.pushState = function(state, unused, url) {
          if (typeof url === 'string' && (url.startsWith('/account') || url.startsWith('/login'))) {
            console.log('Prevented redirect to:', url)
            return
          }
          return originalPushState.apply(this, [state, unused, url])
        }
        
        window.history.replaceState = function(state, unused, url) {
          if (typeof url === 'string' && (url.startsWith('/account') || url.startsWith('/login'))) {
            console.log('Prevented replace state to:', url)
            return
          }
          return originalReplaceState.apply(this, [state, unused, url])
        }
      } else {
        sessionStorage.removeItem('public_route_bypass')
      }
    }
    
    // Run once on initial load
    updatePublicRouteFlag()
    
    // Monitor route changes
    window.addEventListener('popstate', updatePublicRouteFlag)
    
    // Use onBeforeUnmount for cleanup instead of nuxtApp.hook
    // This avoids TypeScript errors with hook types
    onBeforeUnmount(() => {
      window.removeEventListener('popstate', updatePublicRouteFlag)
    })
  }
})
